import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FileBarChart, TrendingUp, DollarSign, Users, Calendar, ChevronRight, FolderKanban } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useUserPermissions } from "@/hooks/useUserPermissions";

const FINANCE_ADMIN_ALLOWED_EMAILS = [
  'lcosta@divuslegalgroup.com',
  'gbumussi@divuslegalgroup.com',
  'njunior@divuslegalgroup.com',
  'atavares@divuslegalgroup.com',
];

const SALES_REPORT_ONLY_EMAILS = [
  'jfagundes@divuslegalgroup.com',
  'cfogaca@divuslegalgroup.com',
  'gsenna@divuslegalgroup.com',
  'rsantana@divuslegalgroup.com',
  'mcarvalho@divuslegalgroup.com',
  'avital@divuslegalgroup.com',
  'wgoes@divuslegalgroup.com',
];
export default function Reports() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { permissions } = useUserPermissions();

  const currentUserEmail = permissions?.email?.toLowerCase() || '';
  const isFinanceAdmin = FINANCE_ADMIN_ALLOWED_EMAILS.includes(currentUserEmail);
  const showOnlySalesReport = SALES_REPORT_ONLY_EMAILS.includes(currentUserEmail) && !isFinanceAdmin;
  
  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-3">
        <FileBarChart className="h-8 w-8 text-primary" />
        <div>
          <h1 className="text-2xl font-bold">{t('reports.title')}</h1>
          <p className="text-muted-foreground">{t('reports.subtitle')}</p>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {!showOnlySalesReport && (
        <Card 
          className="hover:shadow-md transition-shadow cursor-pointer group"
          onClick={() => navigate('/reports/commission-report')}
        >
          <CardHeader className="flex flex-row items-center gap-4">
            <div className="p-2 bg-primary/10 rounded-lg">
              <DollarSign className="h-6 w-6 text-primary" />
            </div>
            <div className="flex-1">
              <CardTitle className="text-lg">Relatório de Comissões</CardTitle>
              <CardDescription>Comissões dos consultores EUA por período</CardDescription>
            </div>
            <ChevronRight className="h-5 w-5 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
          </CardHeader>
        </Card>
        )}

        <Card 
          className="hover:shadow-md transition-shadow cursor-pointer group"
          onClick={() => navigate('/reports/sales-report')}
        >
          <CardHeader className="flex flex-row items-center gap-4">
            <div className="p-2 bg-primary/10 rounded-lg">
              <DollarSign className="h-6 w-6 text-primary" />
            </div>
            <div className="flex-1">
              <CardTitle className="text-lg">{t('reports.salesReport')}</CardTitle>
              <CardDescription>{t('reports.salesReportDesc')}</CardDescription>
            </div>
            <ChevronRight className="h-5 w-5 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
          </CardHeader>
        </Card>

        {!showOnlySalesReport && (
        <>
        <Card
          className="hover:shadow-md transition-shadow cursor-pointer group"
          onClick={() => navigate('/reports/processos-report')}
        >
          <CardHeader className="flex flex-row items-center gap-4">
            <div className="p-2 bg-violet-500/10 rounded-lg">
              <FolderKanban className="h-6 w-6 text-violet-500" />
            </div>
            <div className="flex-1">
              <CardTitle className="text-lg">Relatório de Processos</CardTitle>
              <CardDescription>Total de processos por tipo e status de pagamento</CardDescription>
            </div>
            <ChevronRight className="h-5 w-5 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
          </CardHeader>
        </Card>

        <Card className="hover:shadow-md transition-shadow cursor-pointer">
          <CardHeader className="flex flex-row items-center gap-4">
            <div className="p-2 bg-emerald-500/10 rounded-lg">
              <TrendingUp className="h-6 w-6 text-emerald-500" />
            </div>
            <div>
              <CardTitle className="text-lg">{t('reports.performanceReport')}</CardTitle>
              <CardDescription>{t('reports.performanceReportDesc')}</CardDescription>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">{t('reports.comingSoon')}</p>
          </CardContent>
        </Card>

        <Card className="hover:shadow-md transition-shadow cursor-pointer">
          <CardHeader className="flex flex-row items-center gap-4">
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <Users className="h-6 w-6 text-blue-500" />
            </div>
            <div>
              <CardTitle className="text-lg">{t('reports.teamReport')}</CardTitle>
              <CardDescription>{t('reports.teamReportDesc')}</CardDescription>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">{t('reports.comingSoon')}</p>
          </CardContent>
        </Card>

        <Card className="hover:shadow-md transition-shadow cursor-pointer">
          <CardHeader className="flex flex-row items-center gap-4">
            <div className="p-2 bg-orange-500/10 rounded-lg">
              <Calendar className="h-6 w-6 text-orange-500" />
            </div>
            <div>
              <CardTitle className="text-lg">{t('reports.periodReport')}</CardTitle>
              <CardDescription>{t('reports.periodReportDesc')}</CardDescription>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">{t('reports.comingSoon')}</p>
          </CardContent>
        </Card>
        </>
        )}
      </div>
    </div>
  );
}
